export default String.raw`
.promoBanner2 {
    &__item {
        position: relative;
        display: flex !important;
        flex-direction: column;
        gap: 24px;
    }

    &__text--position {
        position: absolute;
        top: 5%;
    }

    &__image img {
        aspect-ratio: 1;
        object-fit: cover;
        object-position: 85% 50%;
    }

    &__label {        
        &::after {
            content: 'Mobile';
        }
    }

    .timer {
        gap: 8px 0;

        &__heading {
            color: $bannerFontColor;
        }

        &--position {
            margin: 24px 0;
        }

        .countdown {
            gap: 0 8px;

            &__time-unit {
                color: $bannerFontColor;
            }

            &__separator {
                color: $bannerFontColor;
            }

            &__label {
                color: $bannerFontColor;
            }
        }
    }

    .swiper-button-prev, .swiper-button-next {
        display: none;
    }
}
`